/* ===========================================================================
   Grupo Marhel — search.js
   Search modal open/close + predictive search via /search/suggest.json.
   Vanilla JS.
   =========================================================================== */
(function () {
  'use strict';

  function init() {
    var modal = document.querySelector('[data-search-modal]');
    if (!modal) return;
    var input = modal.querySelector('[data-search-input]');
    var results = modal.querySelector('[data-search-results]');
    var routes = (window.theme && window.theme.routes) || {};
    var strings = (window.theme && window.theme.strings) || {};
    var fmt = function (c) { return window.Marhel ? window.Marhel.formatMoney(c) : '$' + (c / 100).toFixed(2); };
    var accent = function (v) { return window.Marhel ? window.Marhel.vendorAccent(v) : '#005677'; };
    var debounceTimer;

    function open() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      if (window.Marhel) window.Marhel.trapScroll(true);
      setTimeout(function () { if (input) input.focus(); }, 50);
    }
    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      if (window.Marhel) window.Marhel.trapScroll(false);
    }

    document.querySelectorAll('[data-search-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    modal.querySelectorAll('[data-search-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    function setHint(text, cls) {
      results.innerHTML = '<div class="' + (cls || 'search-results__hint') + '">' + text + '</div>';
    }

    function search(term) {
      if (!term || term.length < 2) { setHint(strings.search_hint || 'Buscar productos...'); return; }
      fetch((routes.predictiveSearch || '/search/suggest.json') + '?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=8', {
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) { setHint(strings.no_results || 'No se encontraron resultados', 'search-results__empty'); return; }
          var html = '';
          products.forEach(function (p) {
            var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '" alt="" loading="lazy">' : '';
            var price = (p.price_min != null) ? fmt(p.price_min) : '';
            html +=
              '<a class="search-result" href="' + p.url + '">' +
                '<div class="search-result__media">' + img + '</div>' +
                '<div>' +
                  '<span class="search-result__brand" style="color:' + accent(p.vendor) + ';">' + (p.vendor || '') + '</span>' +
                  '<div class="search-result__name">' + p.title + '</div>' +
                  '<span class="search-result__price">' + price + '</span>' +
                '</div>' +
              '</a>';
          });
          results.innerHTML = html;
        })
        .catch(function () { setHint(strings.no_results || 'No se encontraron resultados', 'search-results__empty'); });
    }

    if (input) {
      input.addEventListener('input', function () {
        clearTimeout(debounceTimer);
        var term = input.value.trim();
        debounceTimer = setTimeout(function () { search(term); }, 220);
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
